<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :items="info"
      :items-per-page="8"
      :paginate="true"
      :loading="loading"
      :search="search"
      :footer-props="{ itemsPerPageText: 'Linhas por página' }"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0">
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <v-text-field
              class="ma-0 pa-0"
              v-model="search"
              :placeholder="'Buscar por schema'"
              prepend-inner-icon="mdi-magnify"
              outlined
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.clean`]="{ item }">
        <v-btn text color="primary" @click="cleanPromotion(item)">
          <v-icon class="mr-2">mdi-broom</v-icon>
          Limpar
        </v-btn>
      </template>
      <template v-slot:[`item.logs`]="{ item }">
        <v-btn color="#4ebf53" icon @click="openModal(item)">
          <v-icon>mdi-file-document</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>
    <ModalLogs :dialog="dialog" :schema="schema" @close="dialog = false" />
  </v-card>
</template>

<script>
import toast from "@/commom/toast";
import BaseDataTable from "@/components/BaseDataTable.vue";
import descontos from "@/services/http/descontos/Descontos.js";
import ModalLogs from "./ModalLogs.vue";
export default {
  components: {
    ModalLogs,
    BaseDataTable

  },

  data() {
    return {
      dialog: false,
      search: "",
      schema: "",
      loading: false,
      info: [{ schema: "CCV" }, { schema: "NBS" }],
      headers: [
        {
          text: "Schema",
          value: "schema",
          align: "center",
        },
        {
          text: "Limpar",
          value: "clean",
        },
        {
          text: "Logs",
          value: "logs",
        },
      ],
    };
  },

  methods: {
    cleanPromotion(item) {
      this.$swal({
        title: `Realmente deseja limpar os desconto do schema ${item.schema}?`,
        text: `Esta ação não poderá ser desfeita`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, limpar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.storeCleanPromotion(item.schema);
        }
      });
    },

    async storeCleanPromotion(schema) {
      try {
        await descontos().store({ schema });
        toast("success", "Os descontos foram limpados");
      } catch (error) {
        toast("error", "Falha ao limpar descontos");
        console.log(error);
      }
    },

    openModal(item) {
      this.dialog = true;
      this.schema = item.schema;
    },
  },
};
</script>

<style scoped>
/deep/.v-input__slot {
  background-color: #eef2f7 !important;
  margin: 0 !important;
}
</style>
